import { SingleEdit } from './SingleEdit'

import { useSingleEditSimulationData } from './hooks/useSingleEditSimulationData'

type Props = {
  simulation?: uui.domain.client.rm.SimulationInfo
}

export function SingleEditProvider(props: Props) {
  const { simulation } = props

  const data = useSingleEditSimulationData(simulation)

  return (
    <SingleEdit
      today={data.today}
      simulation={simulation}
      readonly={data.readonly}
      simulationsNames={data.simulationNames}
      calendarSelection={data.calendarSelection}
      firstDayNotArchived={data.firstDayNotArchived}
      maxIntervalLength={data.licensingLimits.planningRange}
      isSelectingArchivedDate={data.isSelectingArchivedDate}
    />
  )
}
